import { buildActiveFilters } from '@anduin/shared';

const MS_PER_DAY = 1000 * 60 * 60 * 24;

export function computeDateRangeDays(start: Date | string | null | undefined, end: Date | string | null | undefined): number | null {
  if (!start || !end) {
    return null;
  }
  const startMs = new Date(start).getTime();
  const endMs = new Date(end).getTime();
  if (Number.isNaN(startMs) || Number.isNaN(endMs)) {
    return null;
  }
  return Math.max(0, Math.round((endMs - startMs) / MS_PER_DAY));
}

export interface PaymentHistoryActiveFiltersInput {
  aiwynPaymentsOnly: boolean;
  dateRangeDays: number | null;
  searchTerm: string;
  columnFilterIds: string[];
}

// A token is emitted when the dimension actually constrains the table's query — not when it
// diverges from a default. `aiwynPaymentsOnly=true` IS the filter (restricts to Aiwyn-only);
// `false` removes the constraint. Any set date range constrains results vs. unbounded.
export function buildActiveFiltersString(input: PaymentHistoryActiveFiltersInput): string {
  const tokens: string[] = [];
  if (input.aiwynPaymentsOnly) {
    tokens.push('aiwyn_only');
  }
  if (input.dateRangeDays !== null) {
    tokens.push('date_range');
  }
  if ((input.searchTerm ?? '').length > 0) {
    tokens.push('search');
  }
  for (const columnId of input.columnFilterIds) {
    tokens.push(`column:${columnId}`);
  }
  return buildActiveFilters(tokens);
}

// Normalises the payment-method wire shape into the string stamped on PAYMENT_HISTORY_REFUND_* events.
// Hasura emits a `string`; the nested `{ type: string }` branch is defensive against legacy callers.
export function resolvePaymentMethodType(input: unknown): string {
  if (input && typeof input === 'object' && 'type' in (input as Record<string, unknown>)) {
    return String((input as { type: unknown }).type ?? '');
  }
  return typeof input === 'string' ? input : '';
}
